// @flow
import React from 'react';

import { useFlightReviews } from '../Common'

export default function CardholderReview() {
  const {
    contactPerson: { contactName, contactEmail, contactMobile },
  } = useFlightReviews()

  const values = [
    { title: 'Name', value: contactName },
    { title: 'Mobile Number', value: contactMobile },
    { title: 'Contact Email', value: contactEmail },
  ];

  return (
    <div className="card-holder-detail">
      <table className="holder-info">
        <tbody>
          {values.map(({ title, value }) => (
            <tr key={title}>
              <td>{title}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/Review/CardholderReview.js